import {EVENTCODES} from "../enum/eventCodes";

const travel_10off_lead_en = window.travel_10off_lead_en;
const travel_10off_lead_zh = window.travel_10off_lead_zh;

export const getBannerImageUrlLabel = (event_cd) => {
    switch (event_cd) {
        case EVENTCODES.Travel10Off:
            return "travel_10_off_banner_url";

        default:
            return "";
    }
};

/**
 * Return empty string when no redirection
 *
 * @param event_cd
 * @returns {string}
 */
export const getBannerRedirectUrl = (event_cd, lang_code) => {
    switch (event_cd) {
        // may add redirect url here
        case EVENTCODES.Travel10Off:
            return lang_code === "zh" ? travel_10off_lead_zh : travel_10off_lead_en;

        default:
            return "";
    }
};